/* eslint-disable react/no-multi-comp */
import React from 'react';
import { isFunction } from 'lodash/lang';

export const AnalyticsContext = React.createContext();

export class AnalyticsProvider extends React.Component {
  sendEvent = (category, action, label, { nonInteraction = true, ...restOptions } = {}) => {
    const options = {
      nonInteraction,
      ...restOptions,
    };
    const { onEvent } = this.props;

    if (onEvent && isFunction(onEvent)) {
      onEvent(category, action, label, options);
      return;
    }

    if (process.env.NODE_ENV === 'development') {
      console.log(`Event: ${[category, action, label].join(' ')}`, options);
    }

    if (window.ga) {
      window.ga('send', 'event', category, action, label, options);
    }
  };

  render() {
    const { children } = this.props;

    const value = {
      sendEvent: this.sendEvent,
    };

    return <AnalyticsContext.Provider value={value}>{children}</AnalyticsContext.Provider>;
  }
}

export class AnalyticsConsumer extends React.Component {
  sendAction = (sendEvent, category, defaultAction, defaultLabel) => (
    action = defaultAction,
    label = defaultLabel,
  ) => sendEvent(category, action, label);

  render() {
    const { children, category, defaultAction, defaultLabel } = this.props;

    const dataProps = {
      'data-event-category': category || null,
      'data-event-action': defaultAction || null,
      'data-event-label': defaultLabel || null,
    };

    return (
      <AnalyticsContext.Consumer>
        {({ sendEvent }) =>
          children({
            dataProps,
            sendAction: this.sendAction(sendEvent, category, defaultAction, defaultLabel),
          })
        }
      </AnalyticsContext.Consumer>
    );
  }
}
